import { createReducer, on } from "@ngrx/store";
import { SAPconfigurationModel } from "../models/sap.model";
import {
  ADD_SAP_CONFIGURATION,
  ADD_SAP_CONFIGURATIONS,
  UPDATE_SAP_CONFIGURATION,
  UPDATE_SAP_CONFIGURATIONS,
} from "../actions/sap.action";

const INITIAL_SAP_CONFIGURATION: SAPconfigurationModel = {};
const INITIAL_SAP_CONFIGURATIONS: SAPconfigurationModel[] = [];

export const SAPConfigurationReducer = createReducer(
  INITIAL_SAP_CONFIGURATION,
  on(ADD_SAP_CONFIGURATION, (_, sap) => sap),
  on(UPDATE_SAP_CONFIGURATION, (state, { sap }) => ({
    ...state,
    ...sap,
  })),
);

export const SAPConfigurationsReducer = createReducer(
  INITIAL_SAP_CONFIGURATIONS,
  on(ADD_SAP_CONFIGURATIONS, (_, { saps }) => saps),
  on(UPDATE_SAP_CONFIGURATIONS, (state, { sap }) => {
    const _sap = state.map((stateSAP) =>
      stateSAP?.id === sap?.id ? { ...stateSAP, ...sap } : stateSAP,
    );

    const assessmentExists = state.find((stateSAP) => stateSAP?.id === sap?.id);
    return assessmentExists ? _sap : [sap, ..._sap];
  }),
);
